import 'rc-slider/assets/index.css'
import React, { useState } from 'react'
import Slider, { Handle } from 'rc-slider'
import styles from './ControlSlider.module.scss'

interface Props {
  label: React.ReactNode
  min: number
  max: number
  value: number
  step?: number | null
  onChange: (value: number) => void
}

const handle = (props: any) => {
  const { value, dragging, index, ...restProps } = props

  return (
    <div className={'rc-tooltip'} style={{ left: `${restProps.offset}%` }}>
      <Handle value={value} {...restProps} />
    </div>
  )
}

export const ControlSlider = ({ label, min, max, value, step = null, onChange }: Props) => {

  const [val, setVal] = useState(value)

  const onInputChanged = (el: any) => {
    setVal(el.target.value)
  }

  const onInputBlur = (el: any) => {
    let val = Number(el.target.value)

    if (isNaN(val)) {
      setVal(value)
      return
    }

    val = val > max ? max : val < min ? min : val

    onChange(val)
  }

  return (
    <div className={styles.root}>
      <div className={styles.controls}>
        <input
          className={styles.input}
          type="text"
          value={val}
          onBlur={onInputBlur}
          onChange={onInputChanged} />

        <div className={styles.slider}>
          <Slider
            className={'control-slider'}
            min={min}
            max={max}
            step={step}
            defaultValue={value}
            handle={handle}
            onAfterChange={onChange}
          />
        </div>
      </div>
      <div className={styles.label}>
        {label}
      </div>
    </div>
  )
}
